/**
* Indexing critical/sync scripts
* * * * * * * * * * * *
*/
var init = {};
window.aSync = {};

import '../styles/index.less';

import { $ } from './plugins/globalJquery.js';
import Plyr from "plyr";
$ = ($ == undefined ? jQuery : $);
import * as defaultResets from './plugins/defaultResets.js';
import { waitFor } from './plugins/helpers.js';

import './plugins/icons.js';
import './plugins/imageLoader.js';
import { breakpoints } from './modules/breakpoints.js';
import { submenu } from './modules/submenu.js';
import { slideDown } from './modules/slidedown.js';
import { share } from './modules/share.js';
import { takeover } from './modules/takeover.js';
import { newsletters } from './modules/newsletters.js';
import { pauseVideo } from './modules/pauseVideo.js';

/**
* Init critical/sync scripts
* * * * * * * * * * * *
*/
init.sync = function() {
	defaultResets.init();
	breakpoints.init();
	submenu.init();
	slideDown.init();
	share.init();
	takeover.init();
	newsletters.init();
	pauseVideo.init();
	init.icons();
	init.imageLoader();
}


/**
* Update breakpoints resize
* * * * * * * * * * * *
*/
breakpoints.switch.device = function(size) {
	$('.load-image').imageLoader();
	$('body').icons.init('.svg-icon');
	// Update aSync functions
	if (typeof aSync.demo != 'undefined') {
		aSync.demo.resize();
	}
};

breakpoints.resized = function() {
	// Update aSync functions
	if (typeof aSync.scroller != 'undefined' && aSync.scroller == true) {
		$(window).scroller.resize();
	}
};

breakpoints.switch.orientation = function() {
	// console.log('Orientation switch');
};

/**
* Init icons
* * * * * * * * * * * *
*/
init.icons = function() {
	$('body').icons({
		// svg : customData.themePath + '/img/output/sprite.svg',
		svg : '/content/themes/dekubus/img/output/sprite.svg',
		offset : 0,
		ajax : true,
		testFallback : false,
		ready: function(prop) {
			// console.log(prop);
		}
	});
	$('body').icons.init('.svg-icon');
}

/**
* Init image loader
* * * * * * * * * * * *
*/
init.imageLoader = function() {
	$('.load-image').imageLoader({
		ready: function(prop) {
			// console.log(prop);
		},
		resize: function(prop) {
			// console.log(prop);
		}
	});
}

/**
* Init scroller
* * * * * * * * * * * *
*/
init.scroller = function() {
	$(window).scroller({
		items : function() {
			if (typeof aSync.courseFooter != 'undefined') {
				aSync.courseFooter.items();
			}
		},
		calculation: function(pos) {
			if (typeof aSync.courseFooter != 'undefined') {
				aSync.courseFooter.calculation(pos);
			}
		},
		animation: function(pos) {
			if (typeof aSync.courseFooter != 'undefined') {
				aSync.courseFooter.animation(pos);
			}
		},
		resize: function() {
			if (typeof aSync.courseFooter != 'undefined') {
				aSync.courseFooter.resize();
			}
		},
	});
}

/**
* Indexing & init non-critical/aSync scripts
* * * * * * * * * * * *
*/
init.aSync = function() {
	initFilter();
	initScroll();
	initCarousel();
	initVideo();
}

const initFilter = function() {
	if ( $( '.content--courses-archive--edu' ).length > 0 ) {
		import(
			/* webpackChunkName: "filter" */
			'./modules/filter-education.js'
		).then(module => {
			aSync.filter = module.filter;
			aSync.filter.init();
		}).catch(error => 'An error occurred while loading the component');
	}
	else if ( $( '.content--courses-archive' ).length > 0 ) {
		import(
			/* webpackChunkName: "filter" */
			'./modules/filter.js'
		).then(module => {
			aSync.filter = module.filter;
			aSync.filter.init();
		}).catch(error => 'An error occurred while loading the component');
	}
};

function initScroll() {
	if (typeof aSync.scroll == 'undefined') {
		import(
			/* webpackChunkName: "scroll" */
			'./modules/scroll.js'
		).then(module => {
			aSync.scroll = module.scroll;
			aSync.scroll.init();
		}).catch(error => 'An error occurred while loading the component');
	}
}

const initCarousel = function() {
	if ( $( '.js-carousel' ).length > 0 ) {
		import(
			/* webpackChunkName: "carousel" */
			'./modules/carousel.js'
		).then(module => {
			aSync.carousel = module.carousel;
			aSync.carousel.create();
		}).catch(error => 'An error occurred while loading the component');
	}
};

const initVideo = function() {
	if ( $( '.video-container' ).length > 0 ) {
		import(
			/* webpackChunkName: "loadVideo" */
			'./modules/loadVideo.js'
		).then(module => {
			aSync.loadVideo = module.loadVideo;
			aSync.loadVideo.init();
		}).catch(error => 'An error occurred while loading the component');
	}

	document.querySelectorAll(".plyr").forEach((playerElement) => {
    let player = new Plyr(playerElement, {
      muted: true,
      loop: { active: true },
      youtube: { noCookie: false, rel: 0, showinfo: 0, iv_load_policy: 3, modestbranding: 1 },
    });
		let poster = playerElement.querySelector(".plyr__poster");
    player.on("pause", (event) => {
			// console.log("pause");
			poster.style.setProperty("display", "block");
			poster.style.setProperty("opacity", "1");

    });

		player.on("play", (event) => {
			// console.log("play");
			setTimeout(() => {
				poster.style.setProperty("display", "none");
				poster.style.setProperty("opacity", "0");
			}, 100);

    });


    player.on("ready", (event) => {
      //player.play();
    });
    // Expose player so it can be used from the console
    // window.player = player;
  });
};

/**
* Init Project
* * * * * * * * * * * *
*/
$(function() {
	init.sync();
	init.aSync();
});
